import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import { Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const OrdersTable = ({ userOrders, selectedOrder, setSelectedOrder, onSubmitCallback, onBack}) => {
    const handleToggle = (value) => () => {
        console.log(value);
        if (selectedOrder === value) {
            setSelectedOrder(null);
        } else {
            setSelectedOrder(value);
        }
    };

    const handleSubmit = () => {
        if (!selectedOrder) {
            return;
        }
        onSubmitCallback();
    };

    return userOrders.length > 0 ? (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Orders found for the customer
            </Typography>
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>Invoice ID</TableCell>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Order Date</TableCell>
                            {/* <TableCell>Type</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {userOrders.map((order, index) => (
                            <TableRow key={`${order.id}-${index}`} onClick={handleToggle(order)}>
                                <TableCell padding="checkbox">
                                    <Checkbox checked={selectedOrder === order} />
                                </TableCell>
                                <TableCell component="th" scope="row">
                                    {order.processor_invoice_id}
                                </TableCell>
                                <TableCell>{order.product_name}</TableCell>
                                <TableCell>{order.order_date}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className="mt-50">
                <button className="button save-btn accent mr-1"
                    onClick={onBack}>
                    Back
                </button>
                <button className="button save-btn accent"
                    onClick={handleSubmit}>
                    Edit Order
                </button>
            </div>
        </React.Fragment>)
        :
        <div className="mt-50">
            <p>Customer Does Not Have Any Orders!</p>
            <button className="button save-btn accent mr-1"
                onClick={onBack}>
                Back
            </button>
        </div>
        ;
};

export default OrdersTable;